import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$agentsFactory} from "../../$agents.factory";

export class AgentSelectComponent implements IController {

  form: any;
  selectedId: any;
  options: any[];
  optionIds: string[];
  accountIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  onChange: Function;


  private agentsRef: any;
  public selectedAgent: any;
  public selectedText: any;

  constructor(private $mdPanel, private $agents: $agentsFactory) {
    this.agentsRef = this.$agents();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())) {
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;
    const accountIdsRef = this.accountIds;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'account-ids="ctrl.accountIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'agent';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.accountIdsRef = accountIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }


        if (!selectedId) {
          this.onChange({agent: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const agent = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({agent: agent, id: selectedId});
            panel.destroy();
          } else {
            this.agentsRef.$asyncValues([selectedId])
              .then((agents) => {
                this.onChange({agent: agents[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({agent: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedAgent = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.agentsRef.$asyncValues([this.selectedId])
          .then((agents) => {
            this.selectedAgent = _.orderBy(agents, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedAgent = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedAgent, 'user.firstName', '') + ' ' + _.get(this.selectedAgent, 'user.lastName', '');
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      options: '<?',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      accountIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./agent-select.html').default,
    controller: AgentSelectComponent
  });

